import React from "react";
import {Box, Typography} from "@mui/material";

function ActivityReviewComment ({comment}) {

    const title = comment?.title?.length ? comment.title : comment?.label;

    return (
        <>
            <Typography component="h3" variant="h3">{title}</Typography>
            <Typography component="p" mb={2}>{comment?.description}</Typography>
            <Box className="comment">
                <Typography component="p">{comment?.response}</Typography>
            </Box>
        </>
    )
}

export default ActivityReviewComment;